import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { isAddress, type Address } from "viem";
import { useAccount } from "wagmi";

export const useIsWhale = (overrideAddress?: Address) => {
    const { address: accountAddress } = useAccount();

    const resolvedAddress = overrideAddress || accountAddress;

    const {
        data: isWhale,
        isLoading,
        isPending,
    } = useQuery<boolean>({
        queryKey: ["isWhale", resolvedAddress],
        queryFn: async () => {
            if (!resolvedAddress) return false;
            if (!isAddress(resolvedAddress)) return false;
            try {
                const response = await axios.get<{ isWhale: boolean }>(`/api/protocol/user-status/${resolvedAddress}`);
                return response.data.isWhale;
            } catch (error) {
                console.error("Error checking whale status:", error);
                return false;
            }
        },
        enabled: !!resolvedAddress,
        staleTime: 60 * 1000,
    });

    return {
        isWhale,
        isLoading,
        isPending,
    };
};
